import {Injectable} from "@angular/core";
import {FuseMockApiService} from "../../../core/mock-api";
import {
  SS_CHECKOUT_ENDPOINT,
  SS_PRINT_ENDPOINT,
  SsResult,
  SsResultStatusCode
} from "../../../features/stockstore-pos/stockstore-pos.types";
import {CartSsCheckoutResponse, SsCheckoutRespDiscountInfo} from "../../../features/cart/cart.types";


@Injectable({
  providedIn: 'root'
})
export class CheckoutSSMockApi {

  private readonly failResult: SsResult<any> = {
    isSuccess: false,
    errorMessages: [],
    statusCode: SsResultStatusCode.ERR_PRINTER_KO,
    result: "ok"
  };

  constructor(private _fuseMockApiService: FuseMockApiService) {
    this.registerHandlers();
  }

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {

    // -----------------------------------------------------------------------------------------------------
    // @ Checkout POST: Handles mock of SS checkout API
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService
      .onPost("http://127.0.0.1:1221/" + SS_CHECKOUT_ENDPOINT, 1000)
      .reply((request) => {

        // Mock specific behaviour for calculate mode.
        if (request.request.body.checkoutMode == "calculate") {
          return [200, this.generateMockResponse(request.request.body)];
        }

        return [
          200,
          this.generateMockResponse(request.request.body)
        ];
      });

    // -----------------------------------------------------------------------------------------------------
    // @ PRINT POST: Handles mock of SS print API
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService
      .onPost("http://127.0.0.1:1221/" + SS_PRINT_ENDPOINT, 1000)
      .reply(() => {

        return [
          200,
          {
            isSuccess: true,
            errorMessages: [],
            statusCode: SsResultStatusCode.OK,
            result: {
              transactionNum: "DEMO-" + Date.now(),
              kdsCheckNumber: "DEMO"
            }
          }
        ];
      });


  }

  /**
   * Generate mock response with discounts based on actual cart items
   */
  private generateMockResponse(requestBody: any): SsResult<CartSsCheckoutResponse> {
    console.log('Mock API - Calculate Request Body:', requestBody);

    const hasActiveCoupons = requestBody.coupons && requestBody.coupons.length > 0;

    // Calculate actual subtotal from cart items
    let actualSubTotal = 0;
    if (requestBody.items) {
      requestBody.items.forEach((item: any) => {
        const itemTotal = (item.price * item.quantity) / 100; // Convert from cents to euros
        actualSubTotal += itemTotal;
      });
    }

    const forceNoCouponsResponse = false;

    if (!hasActiveCoupons || forceNoCouponsResponse) {
      console.log('No active coupons - returning response without discounts');
      // No coupons active - return response without discounts
      return {
        isSuccess: true,
        errorMessages: [],
        statusCode: SsResultStatusCode.OK,
        result: {
          subTotal: Math.round(actualSubTotal * 100), // Convert back to cents
          totalDiscount: 0,
          cartTotal: Math.round(actualSubTotal * 100),
          cartEntriesDiscounts: [],
          cartDiscounts: [],
          invalidatedCoupons: []
        }
      };
    }

    // Extract cart entry IDs from the request
    const cartEntryIds: string[] = [];
    if (requestBody.items) {
      requestBody.items.forEach((item: any) => {
        if (item.cartEntryId) {
          cartEntryIds.push(item.cartEntryId);
        }
      });
    }

    // Generate item-level discounts for some cart entries
    const cartEntriesDiscounts: SsCheckoutRespDiscountInfo[] = [];
    if (cartEntryIds.length > 0) {

      // Apply discount to first item if available
      if (cartEntryIds[0]) {
        const firstItemDiscount = {
          cartEntryId: cartEntryIds[0],
          amount: 9000, // 90 cents discount
          promoName: 'Sconto 10%',
          couponCode: 'ELEC10'
        };
        cartEntriesDiscounts.push(firstItemDiscount);
        console.log('Applied discount to first item:', firstItemDiscount);
      }

      // Apply discount to second item if available
      /*if (cartEntryIds[1]) {
        const secondItemDiscount = {
          cartEntryId: cartEntryIds[1],
          amount: 30,
          promoName: 'Buy 2 Get 1',
          couponCode: 'BUY2GET1'
        };
        cartEntriesDiscounts.push(secondItemDiscount);
        console.log('Applied discount to second item:', secondItemDiscount);
      }*/
    }

    // Generate cart-level discounts
    const cartDiscounts: SsCheckoutRespDiscountInfo[] = [
      {
        amount: 40,
        promoName: 'Loyalty Discount',
        couponCode: 'LOYALTY2024'
      }
    ];
    console.log('Cart-level discounts:', cartDiscounts);

    // Calculate totals
    const itemDiscountsTotal = cartEntriesDiscounts.reduce((sum, discount) => sum + discount.amount, 0);
    const cartDiscountsTotal = cartDiscounts.reduce((sum, discount) => sum + discount.amount, 0);
    const totalDiscount = itemDiscountsTotal + cartDiscountsTotal;
    const subTotal = Math.round(actualSubTotal * 100); // Convert to cents
    const cartTotal = subTotal - totalDiscount;

    const response: SsResult<CartSsCheckoutResponse> = {
      isSuccess: true,
      errorMessages: [],
      statusCode: SsResultStatusCode.OK,
      result: {
        subTotal,
        totalDiscount,
        cartTotal,
        cartEntriesDiscounts,
        cartDiscounts,
        invalidatedCoupons: []
      }
    };

    // Mock coupon removal if REMOVE or REMOVE2 coupons are in the cart
    response.result.invalidatedCoupons = [];
    if (requestBody.coupons) {
      if (requestBody.coupons.includes("REMOVE")) {
        response.result.invalidatedCoupons.push({
          couponCode: 'REMOVE',
          reasonCode: 'PROMOTION_CONDITIONS_NOT_MET'
        });
      }
      if (requestBody.coupons.includes("REMOVE2")) {
        response.result.invalidatedCoupons.push({
          couponCode: 'REMOVE2',
          reasonCode: 'PROMOTION_CONDITIONS_NOT_MET'
        });
      }
    }


    console.log('Mock API Response Summary:', {
      subTotal: response.result.subTotal / 100 + '€',
      totalDiscount: (response.result?.totalDiscount ?? 0) / 100 + '€',
      cartTotal: response.result.cartTotal / 100 + '€',
      itemDiscountsCount: cartEntriesDiscounts.length,
      cartDiscountsCount: cartDiscounts.length
    });

    return response;
  }
}
